module.exports = __webpack_public_path__ + "static/media/plus.e36ceea5.svg";